import {
  type PrimaryLocation,
  type RestaurantLocation,
} from "@dashboard/types";
import { type ReduxState } from "@dashboard/types/reduxState";

import { RestaurantChangedAction } from "./restaurantReducer";

export type LocationReducerAction =
  // The primary location is derived from the restaurant document, which the
  // locations listener does not cover.
  | { type: "PRIMARY_LOCATION_UPDATED"; payload: PrimaryLocation }
  | { type: "FETCHED_LOCATIONS"; payload: RestaurantLocation[] }
  | RestaurantChangedAction;

export const locationReducer: (
  state: ReduxState["location"] | undefined,
  action: LocationReducerAction
) => ReduxState["location"] = (
  state: ReduxState["location"] = {
    initialLocationsLoading: true,
    locations: [],
  },
  action: LocationReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_CHANGED":
      return {
        ...state,
        initialLocationsLoading: true,
      };

    case "PRIMARY_LOCATION_UPDATED":
      return {
        ...state,
        locations: state.locations.map((location) =>
          location.isPrimary ? action.payload : location
        ),
      };

    case "FETCHED_LOCATIONS":
      return {
        ...state,
        initialLocationsLoading: false,
        locations: action.payload, // ordering is done in the action
      };
    default:
      return state;
  }
};
